enum UtilityDataModule {
  //Display Notes
  FAQ_BASIC_DETAILS = "FAQ_BASIC_DETAILS",
  PARTICIPANT_PROFILE = "PARTICIPANT_PROFILE",
  ORG_ADMIN_PARTICIPANTS_LIST_PROFILE = "ORG_ADMIN_PARTICIPANTS_LIST_PROFILE",
  ORG_ADMIN_PARTICIPANTS_PROFILE = "ORG_ADMIN_PARTICIPANTS_PROFILE",
  ORG_ADMIN_ORGANIZATION_PROFILE = "ORG_ADMIN_ORGANIZATION_PROFILE",
  PARTICIPANT_SELECTION_REQUEST = "PARTICIPANT_SELECTION_REQUEST",
  PARTICIPANT_SELECTION_REQUEST_AND_OPTIN = "PARTICIPANT_SELECTION_REQUEST_AND_OPTIN",
  PARTICIPANT_SELECTION_OPTIN = "PARTICIPANT_SELECTION_OPTIN",
  ORG_ADMIN_PARTICIPANT_SELECTION_REQUEST = "ORG_ADMIN_PARTICIPANT_SELECTION_REQUEST",
  ORG_ADMIN_ORGANIZATION_SELECTION_REQUEST = "ORG_ADMIN_ORGANIZATION_SELECTION_REQUEST",
  ORG_ADMIN_PARTICIPANT_SELECTION_REQUEST_AND_OPTIN = "ORG_ADMIN_PARTICIPANT_SELECTION_REQUEST_AND_OPTIN",
  ORG_ADMIN_PARTICIPANT_SELECTION_OPTIN = "ORG_ADMIN_PARTICIPANT_SELECTION_OPTIN",
  ORG_ADMIN_ORGANIZATION_SELECTION_OPTIN = "ORG_ADMIN_ORGANIZATION_SELECTION_OPTIN",
  ORG_ADMIN_PARTICIPANTS_LIST_SELECTION_REQUEST = "ORG_ADMIN_PARTICIPANTS_LIST_SELECTION_REQUEST",
  ORG_ADMIN_PARTICIPANTS_LIST_SELECTION_REQUEST_AND_OPTIN = "ORG_ADMIN_PARTICIPANTS_LIST_SELECTION_REQUEST_AND_OPTIN",
  ORG_ADMIN_PARTICIPANTS_LIST_SELECTION_OPTIN = "ORG_ADMIN_PARTICIPANTS_LIST_SELECTION_OPTIN",
  ORG_ADMIN_ORGANIZATION_ASSIGN_MEETING_REP = "ORG_ADMIN_ORGANIZATION_ASSIGN_MEETING_REP",
  PARTICIPANT_MEETING_ACCEPT = "PARTICIPANT_MEETING_ACCEPT",
  PARTICIPANT_ADDITIONAL_MEETING_ACCEPT = "PARTICIPANT_ADDITIONAL_MEETING_ACCEPT",
  PARTICIPANT_SCHEDULE = "PARTICIPANT_SCHEDULE",
  ACTIVITY_ADMIN_PROFILE = "ACTIVITY_ADMIN_PROFILE",
  PARTICIPANT_VIEW_EXHIBITORS_LIST = "PARTICIPANT_VIEW_EXHIBITORS_LIST",
  PARTICIPANT_VIEW_SPONSOR_LIST_EVENT = "PARTICIPANT_VIEW_SPONSOR_LIST_EVENT",
  PARTICIPANT_VIEW_EXHIBITORS_LIST_EVENT = "PARTICIPANT_VIEW_EXHIBITORS_LIST_EVENT",
  ACTIVITY_ADMIN_SHORTLIST = "ACTIVITY_ADMIN_SHORTLIST",
  ACTIVITY_ADMIN_ACCEPT_REJECT = "ACTIVITY_ADMIN_ACCEPT_REJECT",
  ACTIVITY_ADMIN_MARK_ATTENDANCE = "ACTIVITY_ADMIN_MARK_ATTENDANCE",
  ACTIVITY_ADMIN_MANAGE_ACTIVITIES = "ACTIVITY_ADMIN_MANAGE_ACTIVITIES",
  PARTICIPANT_REIMBURSEMENT = "PARTICIPANT_REIMBURSEMENT",
  PARTICIPANT_ADD_TO_SCHEDULE = "PARTICIPANT_ADD_TO_SCHEDULE",
  ORG_ADMIN_ORGANIZATION_SCHEDULE = "ORG_ADMIN_ORGANIZATION_SCHEDULE",
  REGISTRATION_FORM_CONFIRMATION = "REGISTRATION_FORM_CONFIRMATION",
  ORG_ADMIN_ORGANIZATION_EXHIBITOR_PROFILE = "ORG_ADMIN_ORGANIZATION_EXHIBITOR_PROFILE"
}

export default UtilityDataModule;
